import {
  EVENT_SET_PRIVATE_SPACE_FIELD,
  EventSetPrivateSpaceFieldPayload,
} from '@weblite/ts-action/private-space'

import { serverSub } from '$func/subscription'
import { privateSpaceStorage } from './storage'

serverSub.subscribe(
  EVENT_SET_PRIVATE_SPACE_FIELD,
  ({ roomUpdate }: EventSetPrivateSpaceFieldPayload) =>
    privateSpaceStorage.set(roomUpdate),
)
